import type * as ngRouter from '@uirouter/angularjs';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { AppStore } from '~/types/main.types';

import { MixableBaseController } from '../../../common/component';
import { selectedReportSelector } from '../../../reducers/selectors';
import { ExplorerSelectors } from '../../../selectors/explorer.selectors';
import { FeatureToggleService } from '../../../services/feature-toggle-service';
import { FlamingoService } from '../../../services/flamingo-service';
import { ReportViewDataService } from '../services';

class ReportVisualizationsExplore extends MixableBaseController implements angular.IOnInit {
  static $inject = [
    '$state',
    '$window',
    'RxStoreService',
    'ReportViewDataService',
    '$timeout',
    'RxStoreService',
    'FeatureToggleService',
    'FlamingoService',
  ];

  owner: any;
  loaded$: Observable<boolean>;
  private token$: Observable<string>;
  private exploreEnabled$: Observable<boolean>;
  private chartDataExportEnabled$: Observable<boolean>;
  private sidebarOpen = true;
  private vizType = '@mode-vegas/vegas';

  constructor(
    private $state: ngRouter.StateService,
    private $window: angular.IWindowService,
    private store: AppStore,
    private reportViewData: ReportViewDataService,
    private $timeout: angular.ITimeoutService,
    private rxStoreService: AppStore,
    private featureToggleService: FeatureToggleService,
    flamingoService: FlamingoService // for side effects
  ) {
    super();
  }

  $onInit(): void {
    this.owner = this.reportViewData.reportOwner;

    this.loaded$ = this.store.select(selectedReportSelector).pipe(
      map((selectedReport) => !selectedReport.pollingReportRun),
      takeUntil(this.destroyed$)
    );

    const chart$ = this.rxStoreService.select(ExplorerSelectors.getChart).pipe(filter((c) => c != null));

    this.token$ = chart$.pipe(map((c) => c.token));
    this.exploreEnabled$ = this.featureToggleService.featureExploreEnabled$;
    this.chartDataExportEnabled$ = this.featureToggleService.featureChartDataExportEnabled$;
  }

  back() {
    const partialStateIfRunExist = this.reportViewData.getRunStateIfRunTokenExists();
    this.reportViewData.navigate({ ...partialStateIfRunExist, name: `${partialStateIfRunExist.name}.dashboard` });
  }

  onDismiss() {
    this.$state.go('reportShow.noRuns.dashboard');
  }
}

export const ID = 'reportVisualizationsExplore';

export const reportVisualizationsExplore: angular.IComponentOptions = {
  template: `
    <div class="explorer-container"
      ng-if="ctrl.loaded$ | async: this"
    >
      <viz-explorer
        token="ctrl.token$ | async:this"
        chart-data-export-enabled="ctrl.chartDataExportEnabled$ | async: this"
        explore-enabled="ctrl.exploreEnabled$ | async:this"
      ></viz-explorer>
    </div>

    <mode-explorations-file-exports></mode-explorations-file-exports>
  `,
  controller: ReportVisualizationsExplore,
  controllerAs: 'ctrl',
};
